import {
  GET_BASE_SETTINGS,
  UPDATE_BASE_SETTING,
  BASE_SETTINGS,
  BASE_SETTING_ERROR,
  BASE_SETTING_SUCCESS,
} from '../../actions';

const INIT_STATE = {
  settings: [],
  loading: false,
  error: '',
  success: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BASE_SETTINGS:
    case UPDATE_BASE_SETTING:
      return {
        ...state,
        loading: true,
        error: '',
        success: '',
      };
    case BASE_SETTINGS:
      return {
        ...state,
        settings: action.payload,
      };
    case BASE_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        success: action.payload.message,
      };
    case BASE_SETTING_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };
    default:
      return { ...state };
  }
};
